import { render } from "./directionIcons.vue?vue&type=template&id=84b6ff38&scoped=true"
import script from "./directionIcons.vue?vue&type=script&lang=js"
export * from "./directionIcons.vue?vue&type=script&lang=js"

import "./directionIcons.vue?vue&type=style&index=0&id=84b6ff38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b6ff38"]])

export default __exports__